import { IconWrapper } from '../runtime';
export default IconWrapper('insert', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M15 7.99976C15 11.8657 11.866 14.9998 8 14.9998C4.13401 14.9998 1 11.8657 1 7.99976C1 4.13376 4.13401 0.999756 8 0.999756C11.866 0.999756 15 4.13376 15 7.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.75 8H8M8 8H11.25M8 8V11.25M8 8V4.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});